// extracted by mini-css-extract-plugin
module.exports = {"contentfulRichText":"contentfulRichText___2__sG","hrWrapper":"hrWrapper___T4xBR","hrbreak":"hrbreak___3tAI8","chowbusBlockquote":"chowbusBlockquote___5vDkF"};